import { Box, Chip, CircularProgress, useMediaQuery } from "@mui/material";
import React, { useEffect, useState } from "react";
import { Stack } from "@mui/system";
import { useDispatch, useSelector } from "react-redux";
import CenteredPagination from "../UI/CenteredPagination";
import Listing from "./Listing";
import ResultsHeader from "./ResultsHeader";
import { fetchListing } from "../../store/CaseSearch/actions";
import NoResultsFound from "../UI/NoResultsFound";
import CaseDetailDialog from "../../dialogs/CaseDetailDialog";
import LogoLoader from "../UI/LogoLoader";

const LegalTerms = ({
  searchKeyword,
  currentPage,
  setCurrentPage,
  openJudgement,
  setOpenJudgement,
  openJudgementText,
  setOpenJudgementText,
}) => {
  const listingType = "legalTerms";
  const category = "legal_term";
  const isMobileView = useMediaQuery((theme) => theme.breakpoints.down("lg"));

  const dispatch = useDispatch();

  const legalTermsFilters = useSelector(
    (state) => state.listingFilters?.legalTerms,
  );
  const letter = legalTermsFilters?.letter;

  const legalTerms = useSelector((state) => state?.listings?.legalTerms);
  const { loading, data } = legalTerms;

  const legalTermsCount = data?.["@odata.count"];

  const [resultsCount, setResultsCount] = useState(10);
  const [openCaseInsights, setOpenCaseInsights] = useState(false);
  const [loadingCaseInsights, setLoadingCaseInsights] = useState(false);

  const closeCitationAndText = () => {
    if (Object.keys(openJudgement)?.length > 0) {
      setOpenJudgement({});
    }
    if (Object.keys(openJudgementText)?.length > 0) {
      setOpenJudgementText({});
    }
  };

  const handleCitationsClick = (id) => {
    setOpenJudgement((prev) => {
      const isAlreadyOpen = prev[id];

      const newState = isAlreadyOpen ? {} : { [id]: true };
      isAlreadyOpen && setOpenJudgementText({});

      return newState;
    });
  };

  const handlePageChange = (e, value) => {
    setCurrentPage(value);
    closeCitationAndText();
    dispatch(
      fetchListing(
        listingType,
        value,
        resultsCount,
        searchKeyword,
        letter,
        category,
      ),
    );
  };

  const handleResultsCountChange = (e) => {
    const newCount = e.target.value;
    setResultsCount(newCount);
    setCurrentPage(1);
    dispatch(
      fetchListing(listingType, 1, newCount, searchKeyword, letter, category),
    );
  };

  useEffect(() => {
    dispatch(
      fetchListing(
        listingType,
        currentPage,
        resultsCount,
        searchKeyword,
        letter,
        category,
      ),
    );
    setCurrentPage(1);
  }, [letter]);

  return (
    <>
      {/* Chips for mobile view */}
      <Stack
        direction="row"
        flexWrap="wrap"
        gap={1}
        sx={{
          display: { xs: "flex", lg: "none" },
          justifyContent: "start",
          width: "100%",
          mb: "8px",
        }}
      >
        {[{ label: "Letter", value: letter }]
          .filter((filter) => filter.value)
          .map((filter, index) => (
            <Chip
              key={index}
              size="small"
              label={`${filter.label}: ${filter.value}`}
              sx={{
                backgroundColor: "#e3f2fd",
                color: "#1976d2",
                fontSize: { xs: "12px", sm: "14px" },
                fontWeight: "500",
              }}
            />
          ))}
      </Stack>
      {loading ? (
        <Box
          sx={{
            height: "10%",
            marginTop: "24px",
            display: "flex",
            justifyContent: "center",
          }}
        >
          <LogoLoader size={isMobileView ? "sm" : "md"} duration="1s" />
        </Box>
      ) : legalTermsCount === 0 ? (
        <NoResultsFound />
      ) : (
        <>
          <ResultsHeader
            totalResults={legalTermsCount}
            resultsCount={resultsCount}
            handleResultsCountChange={handleResultsCountChange}
            isMobileView={isMobileView}
            label="Legal Terms Found"
          />
          <Listing
            data={data?.value}
            openJudgement={openJudgement}
            openJudgementText={openJudgementText}
            setOpenJudgementText={setOpenJudgementText}
            handleCitationsClick={handleCitationsClick}
            loading={loading}
            isMobileView={isMobileView}
            setOpenCaseInsights={setOpenCaseInsights}
            setLoadingCaseInsights={setLoadingCaseInsights}
          />
          <CenteredPagination
            totalResults={legalTermsCount}
            resultsCount={resultsCount}
            currentPage={currentPage}
            onPageChange={handlePageChange}
          />
        </>
      )}
      <CaseDetailDialog
        open={openCaseInsights}
        onClose={() => setOpenCaseInsights(false)}
        loading={loadingCaseInsights}
      />
    </>
  );
};

export default LegalTerms;
